import * as React from "react";
import styled, { css } from "styled-components";
import { useLocation } from "react-router-dom";

import { breakpoint } from "src/library/utils/styled-media-queries/index";
import { Icon } from "src/library/components/Icon";
import { IRoute } from "src/pages/Router/routes";
import { MenuContext } from "src/core/shared/hooks/menu/useMenu";
import { Icons } from "src/library/components/Icon/types";

export interface FooterMenuItemProps {
  route: IRoute;
}

/**
 * Footer menu item component
 */
const FooterMenuItem: React.ReactFCWithChildren<FooterMenuItemProps> = props => {
  const { route } = props;
  const [ _menuState, { clickMenuItem } ] = React.useContext(MenuContext);
  const location = useLocation();

  // set the classes based on route state
  const menuItemClasses = React.useMemo(() => {
    const classes: string[] = [ "footer-menu-item" ];

    if (location.pathname === route.path || location.pathname === route.loadedPath) {
      classes.push("active");
    }

    return classes.join(" ");
  }, [
    location.pathname,
    route.loadedPath,
    route.path
  ]);

  return (
    <FooterMenuItemWrapper
      className={menuItemClasses}
      title={route.title || ""}
      onClick={() => {
        route.onClick ? route.onClick() : clickMenuItem(route);
      }}
    >
      <Icon
        className="footer-menu-icon"
        icon={route.icon || Icons.CHEVRONRIGHT}
        $fillColor="lightGrey"
        size={20}
      />
    </FooterMenuItemWrapper>
  );
};

export default FooterMenuItem;

const FooterMenuItemWrapper = styled.div`
  ${({ theme }) => css`
    margin-right: ${theme.spacing.margins.sm};
    padding: ${theme.spacing.padding.sm};

    &.active {
      .footer-menu-icon {
        fill: ${theme.colors.white};
      }
    }
    
    ${theme.overrides?.menu?.footerIconColor ? css`
      svg {
        fill: ${theme.overrides.menu.footerIconColor} !important;
      }
      ` : ""}

    &:hover {
      cursor: pointer;
      
      .footer-menu-icon {
        fill: ${theme.overrides?.menu?.footerIconHoverColor ? theme.overrides.menu.footerIconHoverColor : theme.colors.accentLight} !important;
      }
    }

    ${breakpoint("md", theme)} {
      margin-top: ${theme.spacing.margins.sm};
      margin-right: 0;
      padding: 0;

      &:last-child {
        margin-bottom: ${theme.spacing.margins.sm};
      }
    }
  `}`;
